import React from 'react'
import usePosition from './usePosition'

/**
 * Returns a component that when rendered allow two other returns: ref and rect.
 *
 * @returns [Rect, rect, ref]
 */
const useRect = () => {
  const [ref, rect] = usePosition()

  const Rect = ({ style = {}, ...delegated }) => (
    <rect
      className="ai-useRect"
      ref={ref}
      x={0}
      y={0}
      width={'100%'}
      height={'100%'}
      fill={'transparent'}
      {...delegated}
    />
  )

  return [Rect, rect, ref]
}

export default useRect
